import * as STD from '@emersya/mpa-std-lib';

import * as BasketNS                     from '@emersya/mpa-basket-lib';
import CM                                from '@emersya/mpa-components-manager-lib';
import { Block, InputBool, InputSelect } from '@emersya/mpa-components-lib';
import ViewerComponent                   from '../../../viewer/Viewer/Viewer';

export interface IStandingCounterComponentConfiguration extends Block.Configuration {
	text : STD.translationsManager.TranslationMapping;
	textColorMenu : STD.translationsManager.TranslationMapping;
	forceBackgroundColor? : string | null;
	textGraphic : STD.translationsManager.TranslationMapping;
};

export class StandingCounterComponent extends Block.Component {
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNode : ViewerComponent.ProductInstance | null = null;
	isCounter : Boolean = true;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	getWallThickness() {
		// TODO : DEHARDCODE
		return 0.05;
	}

	private computeMatrix() {
		const wdh = this.getWDH();
		const x = wdh.width;
		const y = wdh.height;
		const z = wdh.depth;
		void y;
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const currentCounter = app.component_configuration.productsComponents.find(x => x.type === 'counter');
		if (!currentCounter) {
			throw STD.errors.user('No current partitions head found');
		}
		const boundingBox = currentCounter.boundingBox;
		if (!boundingBox) {
			throw STD.errors.user('Missing bounding box for head partition ' + currentCounter.SKU);
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return ViewerComponent.mtx(
				[ 0, 0, 0 ],
				[ 0, 0, 0 ],
				0
			);
			// throw STD.errors.user('No current option in layout part');
		}
		const layoutId = layoutCurrentOption.id;
		if (layoutId === 'shape-no-wall') {
			return (ViewerComponent.mtx(
				[ x / 2 - boundingBox.width / 2 - 0.25, 0, z / 2 - boundingBox.depth / 2 - 0.2 ],
				[ 1, 1, 1 ],
				0
			));
		} else if (layoutId === 'shape-back-left') {
			return (ViewerComponent.mtx(
				[ x / 2 - boundingBox.width / 2 - 0.25, 0, z / 2 - boundingBox.depth / 2 - 0.2 ],
				[ 1, 1, 1 ],
				0
			));
		} else if (layoutId === 'shape-back') {
			return (ViewerComponent.mtx(
				[ x / 2 - boundingBox.width / 2 - 0.25, 0, z / 2 - boundingBox.depth / 2 - 0.2 ],
				[ 1, 1, 1 ],
				0
			));
		} else if (layoutId === 'shape-back-right') {
			return (ViewerComponent.mtx(
				[ -x / 2 + boundingBox.width / 2 + 0.25, 0, z / 2 - boundingBox.depth / 2 - 0.2 ],
				[ 1, 1, 1 ],
				0
			));
		} else if (layoutId === 'shape-left-back-right') {
			if (product.id === 'business') {
				return (ViewerComponent.mtx(
					[ -x / 2 + boundingBox.width + 0.25, 0, z / 2 - boundingBox.depth / 2 - 0.2 ],
					[ 1, 1, 1 ],
					0
				));
			} else {
				return (ViewerComponent.mtx(
					[ x / 2 - boundingBox.width - 0.25, 0, z / 2 - boundingBox.depth / 2 - 0.2 ],
					[ 1, 1, 1 ],
					0
				));
			}
		} else {
			throw STD.errors.user('Unknown layoutId in counter');
		}
	}

	get components() {
		const counterComponents = app.component_configuration.productsComponents.filter(x => x.type === 'counter');
		if (!counterComponents.length) {
			throw STD.errors.user('Missing counter component');
		}
		return counterComponents;
	};

	get colorsList() {
		const product = app.currentProduct;
		if (!product || !product.reference || !app.viewer.planner) {
			return null;
		}
		const cs = this.components.find(c => c.products.includes(product.reference?.value || ''));
		if (!cs) {
			this.component_throwUserError('');
		}
		const relatedOptions = app.component_configuration.productsOptions.filter(x => (x.component === cs.SKU) &&
			x.products.includes(product.reference?.value || ''));
			return relatedOptions;
	};

	async generateColorsMenu() {
		const product = app.currentProduct;
		if (!product || !product.reference || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		const colorsContainer = this.component_find('@:colors'); 
		const colorsInputSelect = <InputSelect.Component> this.component_find('@:colors.options');
		const currentValue = colorsInputSelect.value;
		let currentValueId = '';
		if (currentValue) {
			currentValueId = currentValue.id;
		}
		for (const c of Array.from(colorsInputSelect.component_outerChilds)) {
			await c.component_delete();
		}
		for (const fakeTitle of colorsInputSelect.component_querySelectorAll('.fake-title')) {
			fakeTitle.remove();
		}
		const cs = this.components.find(c => c.products.includes(product.reference?.value || ''));
		if (!cs) {
			this.component_throwUserError('');
		}
		const relatedOptions = app.component_configuration.productsOptions.filter(x => (x.component === cs.SKU) &&
			x.products.includes(product.reference?.value || ''));
		if (!this.viewerNode || !this.viewerNode.basketPart) {
			throw new Error;
		}
		// if(relatedOptions.length === 0){
		// 	await colorsContainer.component_disable();
		// }else{
		// 	await colorsContainer.component_enable();
		// }
		await colorsContainer.component_evaluateCondition()
		const event = this.component_getEventWhichRepresentNoEvent();
		await app.fillComponentOptions(
			this,
			this.viewerNode.basketPart,
			colorsInputSelect,
			relatedOptions,
			'standing-counter-optionTile',
			event
		);
		const newCurrentValue = colorsInputSelect.component_outerChilds.find(x => x.id === currentValueId);
		if (newCurrentValue) {
			await colorsInputSelect.updateValue(newCurrentValue);
		}
		STD.translationsManager.update(this.component_DOM);
	};

	/** When global product is changed **/
	async insert() {
		const product = app.currentProduct;
		if (this.viewerNode || !product || !product.reference || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		const category = app.viewer.categories.find(x => x.name === 'counter');
		if (!category) {
			this.component_throwLibraryError('');
		}
		const colorsInputSelect = <InputSelect.Component> this.component_find('@:colors.options');
		if (app.isReloading) {
			const instances = Array.from(app.viewer.safe.value.productInstances);
			const node = instances.find(x => x.product.category === category);
			if (!node) {
				return;
			}
			this.viewerNode = node;
			await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue((<any> node).metadata.customImages[ 0 ]);
			await this.generateColorsMenu();
			const selectedColor = app.previousConfigurationMetadata?.basket.products[ 0 ]?.parts.find(x => x.name ===
				'counter')?.currentOption?.name;
			if (selectedColor) {
				await colorsInputSelect.updateValueFromId(selectedColor);
			}
			return;
		}
		const counterProductSchema = this.plannerCategory.products.find(x => x.SKU === `@counter-${ app.currentProductSKU }`);
		if (!counterProductSchema) {
			this.component_throwLibraryError('');
		}
		const rootNode = counterProductSchema.nodes[ 0 ];
		if (rootNode) {
			rootNode.matrix = this.computeMatrix();
		}
		this.viewerNode = await counterProductSchema.instantiate({
			rootLocalId : app.viewer.globalLocalId,
			appendType : 'insert',
			basketPart : [],
			basketUseDynamicTitleBinding : true,
			metadata : {
				id :           this.id,
				customImages : [
					{
						enabled :   true,
						leftRight : 0,
						upDown :    0,
						resize :    1,
						rotate :    0,
						image :     null
					}
				]
			}
		});
		await this.generateColorsMenu();
		if (this.isCounter) {
			await app.viewer.setProductNodesInstancesMatrices([
				{
					localId : this.viewerNode.localId,
					matrix :  this.computeMatrix()
				}
			]);
			const ciData = this.viewerNode?.metadata?.customImages?.[ 0 ];
			if (ciData) {
				await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue(<any> ciData);
			}
			this.viewerNode.setName('counter');
			const defaults = app.component_configuration.productsOptionsDefaults[ product.reference.value ];
			if (defaults) {
				if(product.id === 'siae'){
					const defaultColor = defaults[ 'counter-siae' ];
					if (defaultColor) {
						await colorsInputSelect.updateValueFromId(defaultColor);
					}
				}else{
					const defaultColor = defaults[ 'counter' ];
					if (defaultColor) {
						await colorsInputSelect.updateValueFromId(defaultColor);
					}
				}
			}
		} else {
			await app.viewer.setProductNodesInstancesMatrices([
				{
					localId : this.viewerNode.localId,
					matrix :  ViewerComponent.mtx(
						[ 0, 0, 0 ],
						[ 0, 0, 0 ],
						0
					)
				}
			]);
			const ciData = this.viewerNode?.metadata?.customImages?.[ 0 ];
			if (ciData) {
				await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue(<any> ciData);
			}
			this.viewerNode.setName('counter');
			const defaults = app.component_configuration.productsOptionsDefaults[ product.reference.value ];
			if (defaults) {
				if(product.id === 'siae'){
					const defaultColor = defaults[ 'counter-siae' ];
					if (defaultColor) {
						await colorsInputSelect.updateValueFromId(defaultColor);
					}
				}else{
					const defaultColor = defaults[ 'counter' ];
					if (defaultColor) {
						await colorsInputSelect.updateValueFromId(defaultColor);
					}
				}
			}
		}
	};

	async update() {
		// update nodes matrices
		if (!this.viewerNode) {
			await this.insert();
			if (!this.viewerNode) {
				if(app.isReloading){
					return;
				}
				this.component_throwLibraryError('');
			}
		}
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No current product available!');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return;
		}
		if (this.isCounter) {
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices',
					[
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix()
						}
					]
				]
			]);
		}
	};

	async reset() {
		let check = false;
		if (this.isCounter) {
			check = true;
		}
		await this.remove();
		if (check) {
			this.isCounter = true;
			await this.update();
		}
	};

	async updateRemove() {
		await this.remove();
	};

	async remove() {
		if (!this.viewerNode) {
			return;
		}
		await this.viewerNode.delete();
		this.viewerNode = null;
		this.isCounter = false;
	};

	async onProductChange_before(){
		await this.remove();
		this.isCounter = true;
	};

	async onProductChange_after(){
		const inputBool = <InputBool.Component>this.component_find('@:activation:content.options');
		await inputBool.updateValue(true);
	};

	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		// await super.onValueUpdated(ev);
		if (ev.details.isDefaultValue) {
			return;
		}
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		if (!app.currentProduct) {
			this.component_throwLibraryError('');
		}
		const part = app.currentProduct.getPart([ 'counter' ]);

		const counterParts = app.currentProduct.parts.filter(x => x.id.toLowerCase().includes('counter'));

		await app.transaction(async () => {
			if (ev.details.newValue) {
				this.isCounter = true;
				for (const CP of counterParts) {
					CP.ignoreOnSave = false;
				}
				if (!this.viewerNode) {
					await this.insert();
				}
				const select = <InputSelect.Component> this.component_find('@:colors.options');
				const option = select.value;
				if (option && part.options.length != 0) {
					await part.useOption(option.id, true);
				}
				await this.update();
				this.component_innerChilds.forEach(async element => {
					if (element.id != 'activation') {
						await element.component_enable();
					}
				});
			} else {
				const graphicInput = <InputBool.Component> this.component_find('@:graphic:header.enable');
				if (graphicInput.value) {
					await graphicInput.updateValue(false);
				}
				this.isCounter = false;
				for (const CP of counterParts) {
					CP.ignoreOnSave = true;
				}
				await part.unuseOption();
				await this.updateRemove();
				this.component_innerChilds.forEach(async element => {
					if (element.id != 'activation') {
						await element.component_disable();
					}
				});
			}
		});
	};

	override async component_initialize() {
		await this.component_find('@:activation:content').component_instantiateOuterChild({
			type :          'input-bool',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : <InputBool.Configuration> {
				type :            'yesno',
				defaultValue :    true,
				'@translations' : {
					checked :   {
						'en' : 'Yes',
						'fr' : 'Oui'
					},
					unchecked : {
						'en' : 'No',
						'fr' : 'Non'
					}
				}
			}
		});
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		for (const product of app.basket.basket.products) {
			const ref = product.reference;
			if (!ref) {
				this.component_throwLibraryError('');
			}
			const relateComponent = this.components.find(x => x.products.includes(ref.value));
			if (!relateComponent) {
				this.component_throwLibraryError('');
			}
			// const relatedComponent = app.component_configuration.productsComponents
			const relatedOptions = app.component_configuration.productsOptions.filter(x => x.component === relateComponent.SKU);
			// const partTitleTr = relateComponent.translations[ '@name' ];
			const partTitleTr = app.component_configuration.pdfTranslations[ 'part.counter-auto' ];
			if (!partTitleTr) {
				this.component_throwUserError('');
			}
			const part = product.createPart({
				id :        'counter',
				title :     <string> partTitleTr[ app.currentLanguage ],
				reference : null,
				metaData :  null,
				parts :     [],
				options :   relatedOptions.map(optionDescriptor => {
					// const price = optionDescriptor?.price?.[ app.currentCurrency.id ]?.price;
					const optionTitleTr = optionDescriptor.translations[ '@name' ];
					if (!optionTitleTr) {
						this.component_throwUserError('');
					}
					return {
						id :            optionDescriptor.SKU,
						title :         <string> optionTitleTr[ app.currentLanguage ],
						reference :     { value : optionDescriptor.SKU },
						components :    [],
						metaData :      <any> {
							viewerGroups : optionDescriptor.viewerGroups,
							SKU :          optionDescriptor.additionalData?.SKU,
							RGB :          optionDescriptor.additionalData?.RGB,
							icon :         optionDescriptor.iconURL
						},
						pricingInfo :   !optionDescriptor.pricingInfo ? null : {
							pricing :                 BasketNS.Pricing.deserialize(<BasketNS.Pricing.FinalPricing.ISerialized & BasketNS.Pricing.BoundPricing.ISerialized> optionDescriptor.pricingInfo.pricing),
							volumeComputationMethod : optionDescriptor.pricingInfo.volumeComputationMethod
						},
						technicalFees : null
						// price :         (<any> price || null),
						// taxes :         [],
					};
				})
			});
			await part.initialize();
		}
	};

	async onColorValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		void ev;
		const select = <InputSelect.Component> this.component_find('@:colors.options');
		const option = select.value;
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		const part = app.basket.basket.currentProduct.getPart([ 'counter' ]);
		if (!option) {
			if (part.currentOption) {
				await part.unuseOption();
			}
		} else {
			await part.useOption(option.id);
		}
	};

	getConfiguratorMenu() {
		return this;
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		const planner = app.viewer.planner;
		if (!planner) {
			this.component_throwUserError('');
		}
		const counterComponents = this.components.filter(x => x.type === 'counter');
		if (!counterComponents.length) {
			throw STD.errors.user('Missing counter component');
		}
		const extensionCustomImage : Partial<ViewerComponent.IProductExtension> = {
			customImages : [
				{
					id :                'customImg',
					title :             { en : 'Add logo', fr : 'Ajouter un logo' },
					width :             .96,
					height :            .98,
					mesh :              'comptoir_base.001',
					material :          {
						name :          'logo_comptoir',
						configuration : {
							enabled :  'logo_comptoir',
							disabled : 'off'
						}
					},
					pricingInfo :       null,
					volumeComputation : null
				}
			]
		};
		const extensionCustomImagePrestige : Partial<ViewerComponent.IProductExtension> = {
			customImages : [
				{
					id :                'customImg',
					title :             { en : 'Add logo', fr : 'Ajouter un logo' },
					width :             .96,
					height :            .98,
					mesh :              'comptoir_base.003',
					material :          {
						name :          'logo_comptoir',
						configuration : {
							enabled :  'logo_comptoir',
							disabled : 'off'
						}
					},
					pricingInfo :       null,
					volumeComputation : null
				}
			]
		};
		(<any> this).plannerCategory = app.viewer.createCategory({
			name :        'counter',
			menuActions : {
				edit :      true,
				delete :    false,
				rotate :    true,
				duplicate : false
			},
			products :    counterComponents.reduce<ViewerComponent.Product.IDescriptor[]>(
				(
					a,
					counterComponent
				) => {
					a.push(...counterComponent.products.map(forProductSKU => {
							const SKU = `@counter-${ forProductSKU }`;
							app.viewer.productsExtensionById[ SKU ] = {
								quantity :        null,
								configuratorGet : CM.PropertyOperation.CallOperation.create({
									type :          'call',
									componentPath : this.component_getPath(),
									propertyPath :  'getConfiguratorMenu',
									parameters :    []
								}),
								...forProductSKU === 'confort' || forProductSKU === 'prestige' ? extensionCustomImagePrestige : extensionCustomImage,
							};
							// if (forProductSKU === 'siae') {
							// 	planner.planner.productsExtensionById[ SKU ] = {
							// 		...planner.planner.productsExtensionById[ SKU ],
							// 		presets : app.component_configuration.productsOptions.filter(x => x.component === 'counter-siae').
							// 							map(option => {
							// 								const tr = option.translations[ '@name' ];
							// 								if (!tr) {
							// 									this.component_throwLibraryError('');
							// 								}
							// 								const pricing = option.price ? option.price[ app.currentCurrency.id ] : null;
							// 								return {
							// 									id :      option.SKU,
							// 									name :    tr,
							// 									iconURL : option.iconURL,
							// 									groups :  option.viewerGroups.reduce<Record<string, string>>((a, c) => {
							// 										a[ (<any> c).groupName ] = (<any> c).configurationName;
							// 										return a;
							// 									}, {}),
							// 									price :   pricing ? pricing.price : null
							// 								};
							// 							})
							// 	};
							// }
							return ({
								SKU,
								nodes : [
									{
										SKU :                         <string> counterComponent.viewerComponentSKU,
										projectCode :                 <string> counterComponent.viewerProjectCode,
										localId :                     'global',
										parentLocalId :               'root',
										snappable :                   false,
										fixedPositionSetIds :         null,
										draggable :                   true,
										doNotListAsProductComponent : true,
										tracked :                     true,
										matrix :                      app.viewer.mtx(
											[ 0, 0, 0 ],
											[ 1, 1, 1 ],
											0
										)
									}
								]
							});
						}
					));
					return a;
				},
				[]
			)
		});
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingCounterComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			activation : {
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							label : {
								'@translations' : {
									text : configuration.text
								}
							}
						}
					}
				}
			},
			colors :     {
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							label : {
								'@translations' : {
									text : configuration.textColorMenu
								}
							}
						}
					}
				}
			},
			graphic :    <Partial<ViewerGraphicsNS.Configuration>> {
				forceBackgroundColor :   configuration.forceBackgroundColor,
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							title : {
								'@translations' : {
									text : configuration.textGraphic
								}
							}
						}
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory();
	};
};
export namespace NS {
	export const Component = StandingCounterComponent;
	export type Component = StandingCounterComponent;
	export type Configuration = IStandingCounterComponentConfiguration;
}
;
import manifestXMLSource                 from './StandingCounter.xml';
import './StandingCounter.scss';
import { NS as ViewerGraphicsNS }        from '../../../viewer/Graphics/ViewerGraphics';


CM.declare({
	id :       'standing-counter',
	type :     StandingCounterComponent,
	manifest : manifestXMLSource
});
